



























































import SkillRating from '@/components/SkillRating/index.vue';

export default {
  name: 'DevStack',
  components: {
    SkillRating
  },
  props: {},
  computed: {},
  methods: {}
};
